import { DataBean } from "../DataBean";

export class LoanLine extends DataBean {


    public async getLoanLineCatalog(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getLoanLineCatalog_Number", [id]);
    }

    public async getLoanLine(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.loans.LoanLine_getLoanLine_Number", [id]);
    }

    public async getLoanLinesByAffiliate(id: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getLoanLinesByAffiliate_Number", [id]);
    }
    
    public async getCreditAffiliateByIDAccount(idAccount: any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCreditAffiliateCatalogPorPropiedades_java.util.Map_Number", [
            {IDAccount:idAccount},null
        ]);
    }
    
    public async getLoanLineConceptCatalogPorPropiedades(props:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getLoanLineConceptCatalogPorPropiedades_java.util.Map_Number", [
            props,null
        ]);
    }

}